import { render, staticRenderFns } from "./riskTagLibConf.vue?vue&type=template&id=408f13b6&scoped=true"
import script from "./riskTagLibConf.vue?vue&type=script&lang=js"
export * from "./riskTagLibConf.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "408f13b6",
  null
  
)

export default component.exports